import { CREATE_USER_EVENT } from './constants'

export const createEvent = (event) => ({ type: CREATE_USER_EVENT, event })
